var map = {
	"./bi_logo.svg": 4557,
	"./khaydarin-crystal.svg": 8498,
	"./protoss-carrier.jpg": 7478,
	"./protoss-citadel-of-adun.jpg": 3823,
	"./protoss-dark-templar.jpg": 2892,
	"./protoss-khaydarin-sanctuary.jpg": 2686,
	"./protoss-mothership.jpg": 6935,
	"./protoss-nexus.jpg": 4543,
	"./protoss-observer.jpg": 6150,
	"./protoss-oracle.jpg": 7990,
	"./protoss-probe.jpg": 6032,
	"./protoss-sentry.jpg": 641,
	"./protoss-templar-assembly.png": 8188,
	"./protoss-warp-prism.jpg": 4846,
	"./spear-of-adun.jpg": 3207,
	"./tianhua_logo.png": 893,
	"images/bi_logo.svg": 4557,
	"images/khaydarin-crystal.svg": 8498,
	"images/protoss-carrier.jpg": 7478,
	"images/protoss-citadel-of-adun.jpg": 3823,
	"images/protoss-dark-templar.jpg": 2892,
	"images/protoss-khaydarin-sanctuary.jpg": 2686,
	"images/protoss-mothership.jpg": 6935,
	"images/protoss-nexus.jpg": 4543,
	"images/protoss-observer.jpg": 6150,
	"images/protoss-oracle.jpg": 7990,
	"images/protoss-probe.jpg": 6032,
	"images/protoss-sentry.jpg": 641,
	"images/protoss-templar-assembly.png": 8188,
	"images/protoss-warp-prism.jpg": 4846,
	"images/spear-of-adun.jpg": 3207,
	"images/tianhua_logo.png": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3881;